import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell, { inputClass, inputShadow } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function SignupPage() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password needs at least 6 characters.");
      return;
    }
    setBusy(true);
    try {
      await signup(email.trim(), password, name.trim());
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      testId="signup-page"
      title="CREATE ACCOUNT"
      subtitle="For parents. Kids just need a first name."
    >
      <form onSubmit={submit} className="space-y-3">
        <input
          data-testid="signup-name-input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name (optional)"
          className={inputClass}
          style={inputShadow}
          maxLength={40}
        />
        <input
          data-testid="signup-email-input"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className={inputClass}
          style={inputShadow}
          required
        />
        <input
          data-testid="signup-password-input"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password (6+ characters)"
          className={inputClass}
          style={inputShadow}
          required
        />
        {error && (
          <div
            data-testid="signup-error"
            className="font-display text-base text-white rounded-2xl border-4 border-navy px-4 py-2"
            style={{ backgroundColor: "#FF5A36" }}
          >
            {error}
          </div>
        )}
        <button
          data-testid="signup-submit-btn"
          type="submit"
          disabled={busy}
          className="chunky-btn w-full py-4 text-2xl text-navy disabled:opacity-50"
          style={{ backgroundColor: "#FFC400" }}
        >
          {busy ? "CREATING..." : "SIGN UP"}
        </button>
      </form>

      <p className="font-display text-sm text-navy/60 mt-4">
        We never ask for a kid's email, birthday, or any bank details.
      </p>

      <div className="mt-4 font-display text-base">
        <Link data-testid="go-login-link" to="/login" className="text-navy underline">
          Already have an account? Log in
        </Link>
      </div>
    </AuthShell>
  );
}
